import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import micro_reporter_api from '../apis/micro-reporter-api';
import PrivateRoute from '../guard/auth';
import Chart from './chart/Chart';
import ConnectionCreate from './connection/ConnectionCreate';
import ConnectionList from './connection/ConnectionList';
import ConnectionSettingForm from './connection/ConnectionSettingForm';
import ReportDefinitionList from './connection/ReportDefinitionList';
import Dashboard from './dashboard/Dashboard';
import ChangePassword from './forgetPassword/ChangePassword';
import ForgetPasswordRouter from './forgetPassword/ForgetPasswordRouter';
import ProjectForm from './project/ProjectForm';
import ProjectList from './project/ProjectList';
import ReportPanel from './report/ReportPanel';
import ReportSchedule from './schedules/ReportSchedule';
import SchedulesList from './schedules/SchedulesList';
import UserList from './user/UserList';
import UserReportPermissions from './user/UserReportPermissions';
import { useHistory } from 'react-router-dom';

const KeycloakWrapper = () => {
  const { keycloak } = useKeycloak();
  let history = useHistory();

  keycloak.redirectUri = window.location.origin + '/dashboard';

  const [isReady, setIsReady] = React.useState(false);

  const saveUserToLocalStorageAndNavigateToDashboard = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    setIsReady(true);
  }

  useEffect(() => {
    micro_reporter_api.defaults.headers.common['Authorization'] = 'Bearer ' + keycloak.token;

    if (keycloak.authenticated) {
      micro_reporter_api.get('/micro-reporter/user/me')
        .then(res => {
          saveUserToLocalStorageAndNavigateToDashboard(res.data);
        });
    }
  });

  window.addEventListener("storage", (e) => {
    e.key === 'user' ? keycloak.logout().then(() => {
      localStorage.removeItem('user');
      history.push('/');
    }) : (() => {})();
  });

  return (
    isReady &&
    <div>
      <Router>
        <Switch>
          <Route path="/" exact component={Dashboard} />

          <PrivateRoute
            path="/report"
            exact
            component={ReportPanel}
            customParams={{ authRequired: false }}
          />
          <Route
            path="/connections"
            exact
            component={ConnectionList}
            customParams={{ authRequired: true }}
          />

          <PrivateRoute
            path="/dashboard"
            exact
            component={Dashboard}
            customParams={{ authRequired: false }}
          />

          <PrivateRoute
            path="/users"
            exact
            component={UserList}
            customParams={{ authRequired: true }}
          />
          <PrivateRoute
            path="/user/permissions"
            exact
            component={UserReportPermissions}
            customParams={{ authRequired: true }}
          />
          <PrivateRoute
            path="/connection/form"
            exact
            component={ConnectionCreate}
            customParams={{ authRequired: true }}
          />
          <PrivateRoute
            path="/report/form"
            exact
            component={ConnectionSettingForm}
            customParams={{ authRequired: true }}
          />
          <PrivateRoute
            path="/reports"
            exact
            component={ReportDefinitionList}
            customParams={{ authRequired: false }}
          />
          <PrivateRoute
            path="/chart"
            exact
            component={Chart}
            customParams={{ authRequired: false }}
          />
          <PrivateRoute
            path="/project/form"
            exact
            component={ProjectForm}
            customParams={{ authRequired: false }}
          />
          <PrivateRoute
            path="/projects"
            exact
            component={ProjectList}
            customParams={{ authRequired: false }}
          />

          <PrivateRoute
            path="/schedule"
            exact
            component={ReportSchedule}
            customParams={{ authRequired: false }}
          />

          <PrivateRoute
            path="/schedule/list"
            exact
            component={SchedulesList}
            customParams={{ authRequired: false }}
          />

          <Route
            path="/forgot/password"
            exact
            component={ForgetPasswordRouter}
            customParams={{ authRequired: false }}
          />

          <Route
            path="/reset/password/:id"
            exact
            component={ChangePassword}
            customParams={{ authRequired: false }}
          />
        </Switch>
      </Router>
    </div>
  );
};

export default KeycloakWrapper;
